import { paths } from "helpers/paths";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Form from "./form";

const TrackerLogs = (props) => {
    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(paths.root);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => <Form {...props} transition="left" title="Трекер логи" back={back} />}
                />
            </Switch>
        </div>
    );
};

export default TrackerLogs;
